import type { EditorSample } from "./JsonDocumentEditor";

// The Full pipeline view's template — /studio's PIPELINE_TEMPLATE shape
// (usePipelineState), but every service_name / resource is left "" for the
// user to fill from the suggestion list: /studio's "your-source" style
// placeholders were real text the linter rejected as unknown services, so a
// fresh editor opened with three errors to delete by hand. Shown as the
// empty editor's ghost text and inserted as real text on request
// (PipelineCodeEditor); the "" slots are placeholders — no lint mark, but
// nothing runs or stages until they are filled in.
/** The template's placeholder entries, also what the generator emits for
 *  a missing source / sink so regenerated code keeps the template shape
 *  (pipelineCode.ts). */
export const PLACEHOLDER_STAGES = {
  source: { service_name: "", resource: "", output_encoding: "bson" },
  middleware: { service_name: "", resource: "", output_encoding: "json" },
  sink: { service_name: "", resource: "", output_encoding: "json" },
} as const;

/** The name a fresh pipeline starts with. */
export const TEMPLATE_NAME = "my-pipeline";

const TEMPLATE_DOC = {
  name: TEMPLATE_NAME,
  source: PLACEHOLDER_STAGES.source,
  middlewares: [PLACEHOLDER_STAGES.middleware],
  sinks: [PLACEHOLDER_STAGES.sink],
};

export const PIPELINE_CODE_TEMPLATE = JSON.stringify(TEMPLATE_DOC, null, 2);

/** The editor's "Insert template" entry (empty-state link + context menu). */
export const TEMPLATE_SAMPLE: EditorSample = {
  id: "template",
  label: "Insert template",
  content: PIPELINE_CODE_TEMPLATE,
};
